<template>
<div>

    <wewHeader></wewHeader>

    <wewSteps v-bind:stepActive="1"></wewSteps>

    <section v-if="!noMatch" class="step1 pad-t-20 pad-b-80" style="background: #EFEFEF;margin-top:-100px;">

        <h2 class="car-title text-center color-blue pad-b-20 pad-t-80">{{ submission.make }} <span style="font-weight: 400;">{{ submission.model }}</span></h2>
              
        <div class="container text-center">
            <div class="w-grid inline trim car-details text-left" style="max-width:600px;">
                <div class="w-1-2"><strong>Version</strong></div><div class="w-1-2 text-right">{{ submission.vehicle.description }}</div>
                <div class="w-1-2"><strong>Engine</strong></div><div class="w-1-2 text-right">{{ submission.vehicle.engineNumber }}</div>
                <div class="w-1-2"><strong>Year</strong></div><div class="w-1-2 text-right">{{ submission.vehicle.year }}</div>
                <div class="w-1-2"><strong>Colour</strong></div><div class="w-1-2 text-right">{{ submission.vehicle.colour }}</div>
                <div class="w-1-2"><strong>Fuel</strong></div><div class="w-1-2 text-right">{{ submission.vehicle.fuel }}</div>
                <div class="w-1-2"><strong>Transmission</strong></div><div class="w-1-2 text-right">{{ submission.vehicle.transmission }}</div>
                <div class="w-1-2"><strong>Doors</strong></div><div class="w-1-2 text-right">{{ submission.vehicle.doors }}</div>
                <div class="w-1-2"><strong>Registration</strong></div><div class="w-1-2 text-right"><div class="reg-title text-center">{{ submission.reg }}</div></div>
            </div>
        </div>

        <div class="container text-center question pad-t-40">
            <h2 class="iblock">IS THIS YOUR CAR?</h2>
            <router-link to="step2"><button class="m4c-btn color-white marg-lr-10 marg-b-10">YES</button></router-link>
            <button class="m4c-btn charcoal color-white mar-lr-10 marg-b-10" @click="onNoMatch">NO</button>
        </div>

    </section>

    <section v-if="noMatch" class="step1 pad-b-80">

        <h2 class="car-title text-center pad-b-40">PLEASE ENTER DETAILS OF YOUR <span class="color-blue">CAR</span></h2>
        <form class="car-details-form" @submit.prevent="validateBeforeSubmit('step2')">
        <div class="container text-center">
            <div class="w-grid inline trim car-details" style="max-width:600px;text-align:left;">
               
                    <div class="w-grid trim">
                        <div class="w-1 w-sm-1-2"><strong>Manufacturer</strong></div><div class="w-1 w-sm-1-2"><textbox v-bind:textbox="make"></textbox></div>
                        <div class="w-1 w-sm-1-2"><strong>Model</strong></div><div class="w-1 w-sm-1-2"><textbox v-bind:textbox="model"></textbox></div>
                        <div class="w-1 w-sm-1-2"><strong>Type / version</strong></div><div class="w-1 w-sm-1-2"><textbox v-bind:textbox="description"></textbox></div>
                        <div class="w-1 w-sm-1-2"><strong>Type of fuel</strong></div><div class="w-1 w-sm-1-2"><textbox v-bind:textbox="fuel"></textbox></div>
                        <div class="w-1 w-sm-1-2"><strong>Transmission</strong></div><div class="w-1 w-sm-1-2"><textbox v-bind:textbox="transmission"></textbox></div>
                        <div class="w-1 w-sm-1-2"><strong>Colour</strong></div><div class="w-1 w-sm-1-2"><textbox v-bind:textbox="colour"></textbox></div>
                    </div>
            </div>
        </div>
        <div class="text-center pad-t-40">
            <button type="submit" class="m4c-btn color-white marg-r-10 marg-t-10"><span class="v-top">NEXT STEP</span></button>
        </div>
        </form>
    </section>
    <wewFooterWhite></wewFooterWhite>
</div>
</template>

<script>
import wewHeader from '@/components/Header'
import wewSteps from '@/components/Steps'
import textbox from '@/components/input-text';
import wewFooterWhite from '@/components/wew-footer-white'

export default {
    name: 'step1',
    components: {
        wewHeader,
        wewSteps,
        textbox,
        wewFooterWhite
    },
 data() {
        return {
            noMatch: false,
            make: {
                name: 'Manufacturer',
                placeholder: '',
                class: 'm4c-textbox',
                veeRules: 'required|min:3|max:50',
                value: null
            },
            model: {
                name: 'Model',
                placeholder: '',
                class: 'm4c-textbox',
                veeRules: 'required|min:3|max:50',
                value: null
            },
            description: {
                name: 'Type',
                placeholder: '',
                class: 'm4c-textbox',
                veeRules: 'required|min:3|max:50',
                value: null
            },
            fuel: {
                name: 'Fuel type',
                placeholder: '',
                class: 'm4c-textbox',
                veeRules: 'required|min:3|max:50',
                value: null
            },
            transmission: {
                name: 'Transmission type',
                placeholder: '',
                class: 'm4c-textbox',
                veeRules: 'required|min:3|max:50',
                value: null
            },
            colour: {
                name: 'Colour',
                placeholder: '',
                class: 'm4c-textbox',
                veeRules: 'required|min:3|max:50',
                value: null
            },
            
        }
    },
    beforeMount() {
       
        // increment people
        const incr = parseInt(this.people+1)
        this.$store.dispatch('updatePeople', incr)
    },
computed: {
    people() {
        return this.$store.getters.people
    },
    submission() {
      return this.$store.getters.submission
    }
  },
methods: {
    onNoMatch(){
        this.noMatch = true
        window.scrollTo(0,0);
    },
    validateBeforeSubmit(route) {
        this.$validator.validateAll().then((valid) => {
            if(valid){
                if(this.noMatch) {
                    let payload = {
                        make: this.make.value,
                        model: this.model.value,
                        description: this.description.value,
                        fuel: this.fuel.value,
                        transmission: this.transmission.value,
                        colour: this.colour.value
                    }
                    this.$store.dispatch('storeCustomiseVehicle', payload)
                    console.log('Added custom vehilcle data: ',this.submission)
                }
                this.$router.push(route)
            } else {
                console.log('Custom vehicle form submitted with invalid data')
            }
        })
    }
}
}
</script>

<style>
.step1 .question{
    display:flex;
    flex-flow: row wrap;
    justify-content: center;
    align-items: center;
}

.step1 .question h2{
    font-size: 32px;
    margin-bottom: 10px;
    margin-top: 10px;
    font-weight: 900;
}

h2.car-title{
    text-transform: uppercase;
    font-size: 40px;
    line-height: 40px;
}

.reg-title{
    background:#CCCCCC;
    border-radius: 30px;
    padding: 2px 18px;
    display: inline-block;
    font-size: 18px;
    font-weight:800;
}

.car-details > div{
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 15px;
}


</style>
